import React from "react";

// A subtle SVG background that simulates warp/weft crossing threads
export const TapestryWeave = ({ className = "", opacity = 0.14 }) => {
  return (
    <svg
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <defs>
        <pattern
          id="tapestry-weave"
          width="120"
          height="120"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M0 60 Q30 40 60 60 T120 60"
            fill="none"
            stroke="#C9A87C"
            strokeWidth="0.6"
            opacity="0.6"
          />
          <path
            d="M60 0 Q40 30 60 60 T60 120"
            fill="none"
            stroke="#C9A87C"
            strokeWidth="0.6"
            opacity="0.6"
          />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill="url(#tapestry-weave)"
        style={{ opacity }}
      />
    </svg>
  );
};

export default TapestryWeave;
